import { ProjectDrillingParametersFormationTopBase } from './base/project-drilling-parameters-formation-top-base';

export class ProjectDrillingParametersFormationTop extends ProjectDrillingParametersFormationTopBase { }